import React, { useState } from 'react';
import './index.scss';
import { CnIcon, CnPopup } from '@cainiaofe/cn-ui';

const ReplyItem = (props) => {
  const { onClick, item, depth = 0 } = props;
  const [showSubMenu, setShowSubMenu] = useState(false);
  const iconType = item.icon === undefined ? 'robot' : item.icon;

  const hasChildren = Array.isArray(item.children) && item.children.length > 0;

  if (!hasChildren) {
    return (
      <div
        className="reply"
        onClick={() => {
          onClick({
            label: item.label || item.title,
            value: item.value || item.content,
            type: item.type,
          });
        }}
      >
        {iconType ? <CnIcon type={iconType} size={16} /> : null}
        <div style={{ marginLeft: iconType ? 4 : 0 }}>{item.label || item.title}</div>
      </div>
    );
  }

  let arrowType = showSubMenu ? 'triangle-down-fill' : 'triangle-up-fill';
  if (depth !== 0) arrowType = 'triangle-right-fill';

  return (
    <CnPopup
      v2
      triggerType="click"
      placement={depth === 0 ? 'tl' : 'rt'}
      offset={depth === 0 ? undefined : [4, 0]}
      canCloseByEsc
      canCloseByOutSideClick
      autoFocus
      needAdjust
      onClose={() => {
        setShowSubMenu(false);
      }}
      overlay={
        <div className="chatai-ui-reply-popup">
          {item.children.map((i) => (
            <ReplyItem
              item={i}
              onClick={(...params) => {
                setShowSubMenu(false);
                onClick(...params);
              }}
              depth={depth + 1}
            />
          ))}
        </div>
      }
    >
      <div
        className="reply"
        onClick={() => {
          setShowSubMenu((cur) => !cur);
        }}
      >
        {iconType ? <CnIcon type={iconType} size={16} /> : null}
        <div style={{ marginLeft: iconType ? 4 : 0 }}>{item.label || item.title}</div>
        <CnIcon type={arrowType} size="small" />
      </div>
    </CnPopup>
  );
};

export default ReplyItem;
